export default {
  count: (string, substr) => {
    return string.split(substr).length - 1;
  }
}
